import {
  ChartLine,
  // EllipsisVertical,
  TrendingDown,
  TrendingUp,
} from 'lucide-react';
import React from 'react';
import { PeriodType } from '../../../types/inventory/analyticsType';
import dayjs from 'dayjs';

type Props = {
  title: string;
  currentValue: number;
  previousValue: number;
  change: number;
  currentPeriod?: PeriodType;
  previousPeriod?: PeriodType;
};

export default function InventoryOverviewCard({
  title,
  currentValue,
  previousValue,
  change,
  currentPeriod,
}: Props) {
  const current_date = dayjs(currentPeriod?.to);
  const lastNumMonth = current_date.diff(dayjs(currentPeriod?.from), 'month');
  const lastNumDays = current_date.diff(dayjs(currentPeriod?.from), 'day');
  const lastNumHours = current_date.diff(dayjs(currentPeriod?.from), 'hour');

  return (
    <div className="space-y-4 rounded-lg border border-border relative shadow-sm p-4 sm:p-6">
      <div className="p-3 w-fit rounded-md border border-border shadow-sm ">
        <ChartLine className="size-5 high-emphasis-text" />
      </div>
      {/* MENU BUTTON */}
      {/* <IonicButton
        className="medium-emphasis-text absolute top-2 right-0"
        variant="ghost"
      >
        <EllipsisVertical className="size-4" />
      </IonicButton> */}

      <div className="space-y-1">
        <p className="medium-emphasis-text font-medium capitalize">{title}</p>
        <h3 className="font-semibold high-emphasis-text">{currentValue}</h3>
      </div>
      <p className="medium-emphasis-text font-medium space-x-2">
        <span
          className={`space-x-1 ${currentValue < previousValue ? 'text-red-600' : 'text-green-600'}`}
        >
          {change < 0 ? (
            <TrendingDown className="size-4 inline-block" />
          ) : (
            <TrendingUp className="size-4 inline-block" />
          )}
          <span>{change}%</span>
        </span>
        <span>
          From last{' '}
          {lastNumMonth >= 1
            ? `${lastNumDays} Months`
            : lastNumDays >= 1
              ? `${lastNumDays} Days`
              : `${lastNumHours} Hours`}{' '}
        </span>
      </p>
    </div>
  );
}

//SKELETON FOR COMPONENT
export function InventoryOverviewCardSkeleton() {
  return (
    <div className="space-y-4 rounded-lg border border-border relative bg-gray-50 shadow-sm p-4 sm:p-6 animate-pulse">
      <div className="p-8 w-fit rounded-md bg-gray-100" />
      <div className="space-y-1">
        <span className="block h-5 bg-gray-100" />
        <span className="block h-8 bg-gray-100" />
      </div>
      <span className="block h-5 bg-gray-100" />
    </div>
  );
}
